"use client"
import useSWR from "swr"

import { ApiStatus } from "commonModule/services/common"
import { apiClientCommon } from "services/apiClientCommon"

export const fetcher = async ({
  propertyId,
}: {
  propertyId: string
  url: string
}) => {
  const propertyRes = await apiClientCommon.getPropertyAdditionalInfoApi({
    params: { propertyId },
  })

  if (propertyRes.data.apiStatus !== ApiStatus.SUCCESS) {
    throw Error("getPropertyAdditionalInfo can not be fetched")
  }

  const propertyData = propertyRes?.data?.data

  return propertyData
}

const usePropertyAdditionalInfo = (propertyId: string) => {
  return useSWR(
    propertyId
      ? {
          url: `/api/getPropertyAdditionalInfo`,
          propertyId,
        }
      : null,
    fetcher,
    {
      loadingTimeout: 15000,
      revalidateOnFocus: false,
      dedupingInterval: 3000,
      errorRetryCount: 3,
    },
  )
}

export default usePropertyAdditionalInfo
